// extracted by mini-css-extract-plugin
module.exports = {"inner":"video-preview_inner__2Wg4c","play":"video-preview_play__SSedO","noData":"video-preview_noData__YY_ld"};